import localStore from 'store';

export const saveElementSelection = (id, value) => localStore.set(id, value);
